import { Injectable, EventEmitter } from '@angular/core';
import { Receiver } from '../../../../api/model/receiver';

@Injectable({
  providedIn: 'root'
})
export class FilesUploadService {

  public blockUpload: EventEmitter<boolean> = new EventEmitter();
  public changeReceivers: EventEmitter<boolean> = new EventEmitter();
  private isValid: boolean = false;
  private isCreate: boolean = false;
  private receivers: Receiver[];
  private minPage: number = 1;

  public resetValidation(): void {
    this.isValid = false;
  }

  public setReceivers(value: Receiver[]): void {
    this.receivers = value;
  }

  public setCreate(value: boolean): void{
    this.isCreate = value;
  }

  public getCreate(): boolean {
    return this.isCreate;
  }

  public getMinPage(): number {
    this.minPage = 1;
    this.receivers?.forEach(receiver => {
      receiver.widgetOperation?.forEach(widget => {
        if (widget.page !== 'all' && widget.page !== 'last' && !widget.page.includes('-') && !widget.searchpattern) {
          if (parseInt(widget.page) > this.minPage) this.minPage = parseInt(widget.page);
        }
      })
    })
    return this.minPage;
  }

  public validateFile(file: File, type: number, allDocs: number, index: number): void {
    if (type !== 2) {
      const reader = new FileReader();
      reader.readAsArrayBuffer(file);

      reader.onloadend = () => {
        const xmlString = Buffer.from(reader.result).toString();
        const totalPages = xmlString.match(/\/Type[\s]*\/Page[^s]/g)?.length;

        if (totalPages) {
          if (totalPages >= this.minPage) {
            this.isValid = true;
          }
          if((index + 1) === allDocs){
            this.getStatus();
          }
        } else {
          this.blockUpload.emit(true);
        }
      }
    }
  }


  private getStatus(): void {
    if (this.isValid) {
      this.blockUpload.emit(true)
    }
    else {
      this.blockUpload.emit(false);
    }
  }
}
